import { env } from './env';

export const APP_ENVIRONMENT = env.CHECKPOINT_APP_ENVIRONMENT || 'local';
